import React, { useContext, useState } from "react";
import styles from "./Share.module.scss";
import { Context } from "../Store";
import FacebookButton from "./share/share-buttons/FaceBookButton";
import LinkButton from "./share/share-buttons/LinkButton";
import WhatsAppButton from "./share/share-buttons/WhatsAppButton";
import CopiedContext from "../CopiedContext";
import IsCopiedMessage from "./IsCopiedMessage";

const StarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M8.58737 8.23597L11.1849 3.00376C11.5183 2.33208 12.4817 2.33208 12.8151 3.00376L15.4126 8.23597L21.2215 9.08017C21.9668 9.18848 22.2638 10.0994 21.7243 10.6219L17.5217 14.6918L18.5135 20.4414C18.6409 21.1798 17.8614 21.7428 17.1945 21.3941L12 18.678L6.80547 21.3941C6.1386 21.7428 5.35909 21.1798 5.48645 20.4414L6.47825 14.6918L2.27575 10.6219C1.73617 10.0994 2.03322 9.18848 2.77852 9.08017L8.58737 8.23597Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Share = () => {
  const [state] = useContext(Context);
  const [showCopied, setShowCopied] = useState(false);
  const [hoveredStars, setHoveredStars] = useState(0);
  const copied = { showCopied, setShowCopied };

  const getMediaShareURL = (country, guid) => {
    const domainMap = {
      us: "https://stories.us.flightclubdarts.com/",
      aus: "https://stories.flightclubdarts.com.au/",
      ie: "https://stories.flightclubdarts.ie/",
    };

    const baseURL = domainMap[country] || "https://stories.flightclubdarts.com/";
    return baseURL + guid;
  };

  const addUTMParams = (url, medium) => {
    const utmParams = new URLSearchParams({
      utm_source: "Stories",
      utm_medium: medium,
      utm_campaign: "share_with_friends",
    });

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${utmParams.toString()}`;
  };

  const mediaShareURL = getMediaShareURL(state.country, state.guid);
  const whatsappShareURL = addUTMParams(mediaShareURL, "whatsapp_share");
  const linkShareURL = addUTMParams(mediaShareURL, "link_share");
  const shareText = "Check out the Story of my Flight Club visit: ";
  const sectionName = "Full Story";
  const googleReviewUrl = state.googleurl;
  const isUkStory = state.country === "uk";

  const handleStarClick = () => {
    if (!googleReviewUrl) return;
    window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <CopiedContext.Provider value={copied}>
      <div className={`${styles.shareContainer} section section--padded`}>
        <div>
          <h2>Share the Glory</h2>
          <p>Show them how it went down.</p>
          <div className={styles.shareLinkWrapper}>
            <a className={styles.shareLink}>
              <LinkButton
                mediaShareURL={linkShareURL}
                shareText={shareText}
                mediaType={undefined}
                gameData={undefined}
                sectionName={sectionName}
                showLabel={true}
              />
            </a>
            <a className={styles.shareLink}>
              <WhatsAppButton
                mediaShareURL={whatsappShareURL}
                shareText={shareText}
                mediaType={undefined}
                gameData={undefined}
                sectionName={sectionName}
                showLabel={true}
              />
            </a>
          </div>
        </div>
        {isUkStory && (
          <div className={styles.rateGoogle}>
            <h2>Rate Us</h2>
            <p>Drop us a Google review and help more people discover their inner darts legend </p>
            <div className={styles.stars} onMouseLeave={() => setHoveredStars(0)}>
              {[...Array(5)].map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={`${styles.starButton} ${hoveredStars >= index + 1 ? styles.starActive : ""}`}
                  onMouseEnter={() => setHoveredStars(index + 1)}
                  onClick={handleStarClick}
                  aria-label={`Rate ${index + 1} stars`}
                >
                  <StarIcon />
                </button>
              ))}
            </div>
          </div>
        )}
        <IsCopiedMessage />
      </div>
    </CopiedContext.Provider>
  );
};

export default Share;
